import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, InputLabel, IconButton, TextField } from "@material-ui/core";
import { AddBox, Cancel } from "@material-ui/icons";

// Contexts
import CampaignContext from "../../../../context/campaign/CampaignContext";
import ProductContext from "../../../../context/checkout/products/ProductContext";

const useStyles = makeStyles(() => ({
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
    padding: 10,
  },
  list: {
    height: "100%",
  },
}));

const Upsell = () => {
  const classes = useStyles();

  const { products } = useContext(ProductContext);
  const { form_data, form_error, setFormData, setFormError } =
    useContext(CampaignContext);

  const checkDuplicate = () => {
    // Remove Error Message
    for (let index in form_error.upsell) {
      form_error.upsell[index] = "";
    }

    // Cross Check Duplicate Product ID
    let product_list = {};

    for (let index in form_data.upsell) {
      const id = form_data.upsell[index];

      if (id) {
        if (!Object.keys(product_list).includes(String(id))) {
          product_list[id] = [index];
        } else {
          product_list[id].push(index);
        }
      } else {
        form_error.upsell[index] = "Field cannot be empty!";
      }
    }

    // Insert Error Message
    for (let x in product_list) {
      const indexes = product_list[x];
      if (indexes.length > 1) {
        indexes.forEach(
          (index) => (form_error.upsell[index] = "Upsell Product Duplicated!")
        );
      }
    }

    setFormData(form_data);
    setFormError(form_error);
  };

  const addUpsell = () => {
    const last_idx = Object.keys(form_data.upsell).pop();

    let new_idx = 0;
    if (last_idx) new_idx = parseInt(last_idx) + 1;

    form_data.upsell[new_idx] = "";
    form_error.upsell[new_idx] = "";

    setFormData(form_data);
    setFormError(form_error);
  };

  const removeUpsell = (index) => {
    form_data.upsell.splice(index, 1);
    delete form_error.upsell[index];

    checkDuplicate();
  };

  const handleChange = (e) => {
    const index = e.target.name;
    const value = parseInt(e.target.value.replace(/\s+/g, ""));

    form_data.upsell[index] = value;

    checkDuplicate();
  };

  return (
    <Grid
      item
      xs={6}
      container
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {/* Label */}{" "}
      <Grid item xs={12}>
        <Grid container justifyContent="flex-start" alignItems="center" item>
          <Grid item>
            <InputLabel shrink required>
              Upesell(s){" "}
            </InputLabel>{" "}
          </Grid>{" "}
          <Grid item>
            <IconButton onClick={addUpsell} className={classes.button}>
              <AddBox color="primary" />
            </IconButton>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>
      {/* List */}{" "}
      <Grid item xs={12} className={classes.list}>
        {" "}
        {Object.entries(form_data.upsell).map(([index, upsell_id]) => {
          return (
            <Grid
              key={index}
              item
              xs={12}
              spacing={1}
              container
              alignItems="center"
              justifyContent="flex-start"
            >
              <Grid item xs={10}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  margin="dense"
                  variant="outlined"
                  select
                  SelectProps={{
                    native: true,
                  }}
                  id="upsell"
                  name="upsell"
                  name={index}
                  onChange={handleChange}
                  value={products && upsell_id}
                  error={form_error.upsell[index] ? true : false}
                  helperText={form_error.upsell[index]}
                >
                  <option value="" disabled />{" "}
                  {products &&
                    products.map((each) => {
                      return (
                        <option key={each.id} value={each.id}>
                          {" "}
                          {each.title}{" "}
                        </option>
                      );
                    })}{" "}
                </TextField>{" "}
              </Grid>
              <Grid item xs={2}>
                <IconButton
                  onClick={() => removeUpsell(index)}
                  className={classes.button}
                >
                  <Cancel color="error" />
                </IconButton>{" "}
              </Grid>{" "}
            </Grid>
          );
        })}{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default Upsell;
